import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeft, Clock } from "lucide-react";

import { useLang, useLangPrefix } from "@/contexts/lang";

export const Route = createFileRoute("/about_/organizaciska-struktura")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Организациска структура | Македонијатурист АД" },
			{
				name: "description",
				content:
					"Организациска шема и структура на Македонијатурист АД. Преглед на хиерархијата и одделите во компанијата.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/about/organizaciska-struktura",
			},
		],
	}),
	component: OrganizaciskaStrukturaPage,
});

export function OrganizaciskaStrukturaPage() {
	const t = useLang();
	const prefix = useLangPrefix();

	return (
		<main className="bg-background">
			{/* Hero */}
			<section className="mt-grain relative overflow-hidden bg-primary text-white">
				<div className="pointer-events-none absolute inset-0">
					<div className="absolute -top-[20%] right-0 h-[600px] w-[600px] rounded-full bg-[radial-gradient(closest-side,rgba(201,161,90,0.12),transparent)] blur-[100px]" />
					<div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:60px_60px] [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
				</div>
				<div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-12 sm:py-16 md:py-28">
					<a
						href={`${prefix}/about`}
						className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] uppercase text-white/60 hover:text-white/90 transition-colors duration-300 mb-6 sm:mb-8"
					>
						<ArrowLeft className="h-3.5 w-3.5" />
						{t.organizaciskaStruktura.backLink}
					</a>
					<div className="max-w-3xl">
						<p className="text-xs font-bold tracking-[0.2em] uppercase text-accent">
							{t.organizaciskaStruktura.orgLabel}
						</p>
						<h1 className="mt-4 sm:mt-6 font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.08]">
							{t.organizaciskaStruktura.heading}
						</h1>
					</div>
				</div>
			</section>

			{/* Under construction */}
			<section className="bg-background py-24 sm:py-32 md:py-40">
				<div className="mx-auto max-w-7xl px-4 sm:px-6 flex flex-col items-center text-center gap-6">
					<div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-accent/10">
						<Clock className="h-7 w-7 text-accent" />
					</div>
					<h2 className="font-display text-2xl sm:text-3xl font-medium text-primary tracking-tight">
						{t.organizaciskaStruktura.underConstruction}
					</h2>
					<p className="text-base text-muted-foreground font-light max-w-md leading-relaxed">
						{t.organizaciskaStruktura.comingSoon}
					</p>
				</div>
			</section>
		</main>
	);
}
